export enum PortalsName {
	MASTER = 'Mastersportal',
	BACHELOR = 'Bachelorsportal',
	PHD = 'PhDportal',
	DISTANCE_LEARNING = 'DistanceLearningportal',
	SHORT_COURSE = 'ShortCoursesportal',
}
